module.exports = __webpack_public_path__ + "img/285.a986f25c.png";